import type { ActionResponse } from '../types'

export async function apiCall<T>(endpoint: string, action: string, args?: Record<string, unknown>): Promise<ActionResponse<T>> {
  try {
    const res = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action, args }),
    })
    if (!res.ok && res.headers.get('content-type')?.includes('application/json')) {
      return await res.json()
    }
    if (!res.ok) {
      return { error: { message: `Request failed: ${res.status}`, status: res.status }, data: null }
    }
    return await res.json()
  } catch (err) {
    return { error: { message: (err as Error).message, status: 500 }, data: null }
  }
}
